/* Theme motion (ADR-0136) — the JS half of assets/motion.css.

   1. Scroll reveals: Hydrogen's reveal cascade (rise 20px + 10px blur, staggered).
      Only cards move: the items of below-the-fold grids/rails are tagged [data-reveal]
      and revealed once as they scroll in. Headings stay still, so motion reads as a
      deliberate card entrance rather than every section fading up. Anything on screen at load is
      left alone, so first paint and LCP are never hidden. After revealing, the tag is
      removed so no transform lingers (sticky children, hover effects).
   2. Free-delivery progress fills from 0 when the cart drawer opens.
   All of it is skipped under prefers-reduced-motion. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches) return;

  var STAGGER = 80; // ms between items in a group
  var MAX_STEPS = 5; // cap the cascade so long grids don't wait
  var GROUP_TARGETS =
    'main .shopify-section :is([class*="-grid"], [class*="-rail"], [class*="-tiles"], [class*="-list"]):not([class*="-grid-"]):not([class*="-rail-"]):not([class*="-list-"])';

  function belowFold(el) {
    return el.getBoundingClientRect().top > window.innerHeight;
  }

  function tag(el, step) {
    if (el.hasAttribute('data-reveal') || !belowFold(el)) return false;
    el.setAttribute('data-reveal', '');
    el.style.setProperty('--reveal-delay', Math.min(step, MAX_STEPS) * STAGGER + 'ms');
    return true;
  }

  function collect() {
    var targets = [];
    document.querySelectorAll(GROUP_TARGETS).forEach(function (group) {
      // Card rows have 3+ items; a 2-child "grid" is a layout split (media | copy).
      if (group.closest('[data-reveal]') || group.children.length < 3) return;
      Array.prototype.forEach.call(group.children, function (item, i) {
        if (tag(item, i)) targets.push(item);
      });
    });
    return targets;
  }

  function settle(el) {
    var cleaned = false;
    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      el.removeEventListener('transitionend', onEnd);
      el.removeAttribute('data-reveal');
      el.classList.remove('is-revealed');
      el.style.removeProperty('--reveal-delay');
    }
    function onEnd(event) {
      if (event.target === el && event.propertyName === 'opacity') cleanup();
    }
    el.addEventListener('transitionend', onEnd);
    // transitionend can be skipped (e.g. tab backgrounded mid-reveal): untag anyway.
    var delay = parseFloat(el.style.getPropertyValue('--reveal-delay')) || 0;
    setTimeout(cleanup, delay + 1100);
  }

  function startReveals() {
    if (!('IntersectionObserver' in window)) return;
    var targets = collect();
    if (!targets.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          settle(el);
          el.classList.add('is-revealed');
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  /* Free-delivery bar fills up when the cart drawer opens. */
  function fillProgress(drawer) {
    drawer.querySelectorAll('.at-free-shipping-bar').forEach(function (bar) {
      var target = Number(bar.getAttribute('value'));
      var max = Number(bar.getAttribute('max')) || 1;
      if (!target) return;
      var start = null;
      var DURATION = 900;
      bar.value = 0;
      function frame(time) {
        if (start === null) start = time;
        var t = Math.min((time - start) / DURATION, 1);
        var eased = 1 - Math.pow(1 - t, 4); // easeOutQuart, as the reveal cascade
        bar.value = Math.min(target, max) * eased;
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }

  function watchCartDrawer() {
    var drawer = document.getElementById('at-cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var wasOpen = drawer.classList.contains('is-expanded');
    // global.js may already have reopened it (after a quick add) before this ran.
    if (wasOpen) fillProgress(drawer);
    new MutationObserver(function () {
      var open = drawer.classList.contains('is-expanded');
      if (open && !wasOpen) fillProgress(drawer);
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    startReveals();
    watchCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
